<template>
  <b-container>
    <h2 class="text-center mt-4">紫豆官网文章管理</h2>
    <b-row class="mt-5">
      <b-col cols="2" class="border-right">
        <ul class="nav flex-column">
          <router-link to="/index/list">列表</router-link>
          <router-link to="/index/create">创建</router-link>
        </ul>
      </b-col>
      <b-col cols="10">
        <router-view></router-view>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'ArticleNav'
}
</script>
